import React from 'react';
import { CascadeSymbolConfig, PaytableBracket } from '../../../../core/types/cascade-slot.types';

interface PaytableBracketEditorProps {
  symbols: CascadeSymbolConfig[];
  countBrackets: number[];
  onChange: (symbols: CascadeSymbolConfig[]) => void;
}

export const PaytableBracketEditor: React.FC<PaytableBracketEditorProps> = ({
  symbols,
  countBrackets,
  onChange,
}) => {
  const payingSymbols = symbols.filter(s => s.paytable.length > 0);

  const updatePayout = (symbolIndex: number, bracketIndex: number, payout: number) => {
    const updated = symbols.map((s, i) => {
      if (i !== symbolIndex) return s;
      const newPaytable = s.paytable.map((b, j) =>
        j === bracketIndex ? { ...b, payout } : b
      );
      return { ...s, paytable: newPaytable };
    });
    onChange(updated);
  };

  return (
    <div className="space-y-1">
      <div className="grid gap-1 text-xs text-zinc-500 px-1" style={{ gridTemplateColumns: `60px repeat(${countBrackets.length}, 1fr)` }}>
        <span>Symbol</span>
        {countBrackets.map((b, i) => (
          <span key={i} className="text-center">{b}+</span>
        ))}
      </div>
      {payingSymbols.map((symbol) => {
        const originalIndex = symbols.indexOf(symbol);
        return (
          <div
            key={symbol.id}
            className="grid gap-1 items-center px-1"
            style={{ gridTemplateColumns: `60px repeat(${countBrackets.length}, 1fr)` }}
          >
            <div className="flex items-center gap-1">
              <div
                className="w-4 h-4 rounded-sm"
                style={{ backgroundColor: symbol.color }}
              />
              <span className="text-xs text-zinc-400">{symbol.id}</span>
            </div>
            {symbol.paytable.map((bracket, bIdx) => (
              <input
                key={bIdx}
                className="bg-zinc-800 border border-zinc-700 rounded px-1 py-0.5 text-xs text-zinc-300 w-full text-center"
                type="number"
                value={bracket.payout}
                min={0}
                onChange={(e) => updatePayout(originalIndex, bIdx, parseInt(e.target.value) || 0)}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};
